export { default as Label } from './Label';
export type { Props } from './Label';
export { default as BetaLabel } from './BetaLabel';
